<template>
    <vx-box-glass class="text-slate-700 font-sans">
        <vx-wallpaper :icon="faRectangleHistoryCirclePlus"></vx-wallpaper>
        <div class="relative p-6 xl:p-10 max-w-2xl">
            <h2 class="mb-2 text-xl font-bold">
                Overview
            </h2>
            <p class="text-sm mb-3 font-sans text-slate-700 lg:text-base">
                {{
                    props.orgUnitId
                        ? 'Collections let you organize Groups together so that you can quickly select them when preparing to send a Blast Campaign.'
                        : 'Collections let you organize Groups together so that you can quickly share Segment Templates and Snippet Templates with Groups and OUs.'
                }}
            </p>
            <a href="https://explore.voxie.com/voxiesupport/hc/en-us/articles/group-collections"
                target="_blank"
                rel="noopener noreferrer"
                class="text-sm font-sans font-normal text-sky-500 underline lg:text-base">
                See Docs for More
                <font-awesome-icon widthAuto class="ml-2g"
                    :icon="faArrowRightLong"></font-awesome-icon>
            </a>
        </div>
    </vx-box-glass>
</template>

<script setup>
import { VxBoxGlass, VxWallpaper } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowRightLong, faRectangleHistoryCirclePlus } from '@fortawesome/pro-solid-svg-icons';

const props = defineProps({
    orgUnitId: {
        type: Number,
    },
});
</script>
